import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { SelectGroup } from '../../../components/SelectGroup';
import { Select } from '../../../components/Select';
import Accordion from '../../../components/Accordion';
import Button from '../../../components/Button';
import Icon from '../../../components/Icons';
import Modal from '../../../components/Modal';
import Pagination from '../../../components/Pagination';
import Loading from '../../../components/Loading';
import SearchContainer from '../../../components/SearchContainer';

import { useGlobal } from '../../../contexts/Global/context';
import { getFormattedContractLoginData } from '../../../utils/getFormattedContractLoginData';

import { ContainerButton } from '../../../styles/styles';
import * as S from './styles';

export const SelecaoContrato = ({
    alreadySearched = true,
    contractGroupSelected,
    rowsPerPage = 10,
    setAuthorizationState,
    clearAuthorizationState,
}) => {
    const { contrastTheme } = useGlobal();
    const [dataContract, setDataContract] = useState([]);
    const [loadingAccess, setLoadingAccess] = useState(false);
    const [loadingContracts, setLoadingContracts] = useState(true);
    const [filtered, setFiltered] = useState(dataContract);
    const [isSelected, setIsSelected] = useState(false);
    const [selected, setSelected] = useState([]);

    const [pagination, setPagination] = useState({ activePage: 0, showingData: [] });

    const [qtdPages, setQtdPages] = useState(1);

    const PAGES = Array.from(Array(qtdPages).keys());

    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const history = useHistory();

    const { contractsGroupsList, setDataActiveContract, setContractsList, dataLogin, setDataLogin, setStaticOptions } =
        useGlobal();

    function handleChangePage(activePage) {
        if (activePage >= 0 && activePage < qtdPages) {
            setPagination({
                activePage,
                showingData: [...filtered].splice(activePage * rowsPerPage, rowsPerPage),
            });
        }
    }

    async function handleSearch(value) {
        const filteredValues = dataContract.filter((contract) => {
            const includesNumero = contract.numeroContrato?.toString()?.includes(value?.toString());
            const includesNome = contract.nomeContrato?.toLowerCase()?.includes(value?.toLowerCase());

            return includesNumero || includesNome || !value;
        });

        setQtdPages(Math.ceil(filteredValues.length / rowsPerPage));

        setPagination({
            activePage: 0,
            showingData: [...filteredValues].splice(0 * rowsPerPage, rowsPerPage),
        });

        setFiltered(filteredValues);
    }

    async function handleFowardStep() {
        setLoadingAccess(true);

        const contract = dataContract.find((contrato) => +contrato.numeroContrato === +selected);

        // eslint-disable-next-line prefer-const
        let { formattedContract, profileData, staticOptions } = await getFormattedContractLoginData({
            contract,
            email: dataLogin.email,
        });

        if (formattedContract.isDental) {
            setShowModal(true);

            setModalMessage(
                'Temporariamente, os contratos Odonto não estão disponíveis para acesso neste portal. Você pode acessá-los a partir da área de Empresas do portal GNDI, clicando na opção "Odonto".'
            );

            setLoadingAccess(false);

            return;
        }

        if (formattedContract.vigenciaFutura) {
            setShowModal(true);

            setLoadingAccess(false);

            setModalMessage(
                'Esse contrato possui vigência futura. Acesse novamente após a data de início da vigência.'
            );

            return;
        }

        setDataActiveContract(formattedContract);

        setStaticOptions(staticOptions);

        setDataLogin({ ...dataLogin, ...profileData });

        setAuthorizationState({ grupoContratoSelecionado: true, contratoSelecionado: false, autenticado: true });

        setLoadingAccess(false);

        history.push('/');
    }

    function handleSelect(value) {
        dataContract.every((contract) => {
            if (contract.numeroContrato === value) {
                contract.selected = true;

                setSelected(value);

                setIsSelected(true);

                return false;
            }

            return true;
        });
    }

    useEffect(() => {
        const { contratos: contractsList } = contractsGroupsList.find(
            ({ idGrupoContrato }) => idGrupoContrato === contractGroupSelected.contractGroupNumber
        );

        setContractsList(contractsList);

        setDataContract(contractsList);

        setQtdPages(Math.ceil(contractsList.length / rowsPerPage));

        setPagination({
            activePage: 0,
            showingData: [...contractsList].splice(0, rowsPerPage),
        });

        setFiltered(contractsList);

        setLoadingContracts(false);
    }, []);

    return (
        <S.ContainerCard>
            <Accordion title="Escolha o contrato que deseja acessar" hasCollapse={false}>
                {dataContract.length > rowsPerPage && (
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Nº do contrato',
                            required: true,
                        }}
                        onSearch={handleSearch}
                    />
                )}

                {loadingContracts && <Loading />}

                <SelectGroup style={{ gap: '8px 24px', marginBottom: '32px' }}>
                    {pagination.showingData.map((contract) => {
                        const contractSelected = contract.numeroContrato === selected;

                        return (
                            <S.StyledButton
                                id={contract.numeroContrato}
                                key={contract.numeroContrato}
                                onClick={() => handleSelect(contract.numeroContrato)}
                            >
                                <Select
                                    full
                                    style={{
                                        padding: '0',
                                        margin: '0',
                                        paddingLeft: '24px',
                                        height: '68px',
                                    }}
                                >
                                    <S.StyledIcon>
                                        {contractSelected ? (
                                            <Icon
                                                name="CheckCircleIcon"
                                                color={contrastTheme ? '#FFF333' : '#0B8A1C'}
                                                size={32}
                                            />
                                        ) : (
                                            <Icon
                                                name="CircleIcon"
                                                color={contrastTheme ? '#FFF333' : '#5B5B5FA6'}
                                                size={32}
                                            />
                                        )}
                                    </S.StyledIcon>
                                    <S.ContainerDataContract>
                                        <S.ContractNumber>{contract.numeroContrato}</S.ContractNumber>
                                        <S.ContractName title={contract.nomeContrato}>
                                            {contract.nomeContrato}
                                        </S.ContractName>
                                    </S.ContainerDataContract>
                                </Select>
                            </S.StyledButton>
                        );
                    })}
                </SelectGroup>

                {!loadingContracts && alreadySearched && PAGES.length > 1 && (
                    <Pagination
                        type="simple"
                        loading={loadingContracts}
                        alreadySearched={alreadySearched}
                        pagination={pagination}
                        pages={PAGES}
                        handleChangePage={handleChangePage}
                    />
                )}

                <ContainerButton style={{ marginBottom: '32px' }}>
                    <Button id="backStep" type="secondary" onClick={clearAuthorizationState}>
                        Voltar
                    </Button>
                    <Button
                        id="continueStep"
                        loading={loadingAccess}
                        type="primary"
                        disabled={!isSelected || loadingAccess}
                        onClick={handleFowardStep}
                    >
                        Acessar
                    </Button>
                </ContainerButton>
            </Accordion>

            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        setShowModal(false);
                    }}
                >
                    Entendi
                </Button>
            </Modal>
        </S.ContainerCard>
    );
};
